import { BiomechanicalFault } from './types';

export const BIOMECHANICAL_FAULTS: BiomechanicalFault[] = [
  {
    id: 'fh_flying_long',
    stroke: 'forehand',
    symptom: '正手频繁打出底线出界 (Flying Long Out of Baseline)',
    symptomEn: 'Forehand Constantly Sails Long Past Baseline',
    severity: 'common',
    kineticChainStage: 'contact',
    rootCauses: [
      '击球瞬间拍面向上仰起（拍面过于开放，大于95度）。',
      '缺乏动力链中从下往上的拍头垂直刷球动作（Brush up），只有水平推球。',
      '引拍时拍面未提前关闭，导致向前挥拍触球时光线直冲天空。',
      '下肢没有蓄力蹬地产生向上的垂直动量。'
    ],
    remedyAction: '【关闭拍面 + 垂直动力刷球】引拍向后掉拍头时拍面朝下45度（像照镜子盖住），触球点在身体前方一尺，自下而上刷球后部上方，制造强劲向前翻滚的上旋球（Topspin）下坠弧线。',
    proComparison: {
      flawedHabit: '推击球身，随挥像砍树水平划过肩膀，球缺乏转速出界',
      proExecution: '现代ATP正手极速下掉拍头（Racket Dip），触球瞬间由前臂与雨刷式（Windshield Wiper）旋转刷出每秒50转以上剧烈旋转',
      proPlayerExample: '卡洛斯·阿尔卡拉斯 (Carlos Alcaraz) / 拉法·纳达尔 (Rafael Nadal)'
    },
    correctiveDrills: [
      {
        name: '手抛垂直过网刷球 Drill',
        intensity: '中等 (30球 x 3组)',
        description: '站在发球线后1米，自己手抛球，拍头从膝盖高度启动，仅允许使用前臂与手腕向上刷出高过网2米的急坠球，落点必须在发球线与底线之间。'
      },
      {
        name: '栅栏/球网前贴壁挥拍 Drill',
        intensity: '轻度 (50次慢动作空挥)',
        description: '身体面朝铁丝网站立，距离网20厘米挥拍，强制拍头只能垂直向上划过，纠正向前平推造成的撞网习惯。'
      }
    ]
  },
  {
    id: 'fh_dump_net',
    stroke: 'forehand',
    symptom: '正手下网或触碰网带 (Forehand Dumping into Net)',
    symptomEn: 'Forehand Constantly Hitting Net Tape or Lower Net',
    severity: 'common',
    kineticChainStage: 'follow_through',
    rootCauses: [
      '击球点过靠后，身体重心向后倾斜后仰（Falling Backwards）。',
      '拍头没有掉到球的下方，而是从球的上方盖着往下切或下压。',
      '过网安全余量概念缺失，瞄准网带上方几厘米打，缺乏弧线余量。'
    ],
    remedyAction: '【蹬地重心前移 + 下掉拍头】后脚充分蓄力蹬地，引拍时拍头必须低于来球高度至少20-30厘米，身体重心由后向前冲，随挥完整送出至对侧肩膀前方。',
    proComparison: {
      flawedHabit: '触球时上身向后倒，手腕压球向下扣',
      proExecution: '双腿弯曲蓄力，击球瞬间胸口朝向击球目标，随挥充分向前延伸扩展',
      proPlayerExample: '扬尼克·辛纳 (Jannik Sinner) / 诺瓦克·德约科维奇 (Novak Djokovic)'
    },
    correctiveDrills: [
      {
        name: '发球线前跨步送出延伸 Drill',
        intensity: '中等 (25球 x 3组)',
        description: '每次击球后，后腿必须自然顺势向前迈出一步落入场内，强制身体重心向前转移，彻底告别后仰下网。'
      }
    ]
  },
  {
    id: 'fh_tennis_elbow',
    stroke: 'forehand',
    symptom: '手肘外侧/手腕剧烈酸痛 (网球肘与手腕过度代偿)',
    symptomEn: 'Outer Elbow Soreness (Tennis Elbow) & Wrist Strain',
    severity: 'injury_risk',
    kineticChainStage: 'unit_turn',
    rootCauses: [
      '缺乏大肌群参与：未完成转肩转体（Unit Turn），单纯用手腕和手臂发力拉拽球拍。',
      '击球点击球过迟（Behind the body），手肘被迫在身体后侧承受全部网球冲击力。',
      '握拍过度死捏（Grip Death Grip），肌肉僵硬无法缓冲冲击波。'
    ],
    remedyAction: '【躯干转体驱动 + 早期前伸击球】以非持拍手引拍带动双肩转动90度，击球点前移至肚脐前方30-40厘米，握拍力度放松至1-10分中的3分，击球靠髋腹转动而非小臂甩击。',
    proComparison: {
      flawedHabit: '身体正对球网，完全依靠小臂与手腕弯曲拉拽击球',
      proExecution: '骨盆与胸腔完整转动蓄力，手臂如皮鞭末梢自然随动',
      proPlayerExample: '罗杰·费德勒 (Roger Federer)'
    },
    correctiveDrills: [
      {
        name: '非持拍手指向来球转体感知 Drill',
        intensity: '轻度 (每日40次)',
        description: '在整个引拍过程中，左手（非持拍手）始终伸向右侧并指向来球，强迫转肩达到90度，触球前左手收向胸前释放转体动力。'
      }
    ]
  },
  {
    id: 'bh_two_hand_weak',
    stroke: 'backhand',
    symptom: '双反发不上力，回球软弱易被压制 (Weak Two-Handed Backhand)',
    symptomEn: 'Weak, Floaty Two-Handed Backhand Lacking Pace',
    severity: 'common',
    kineticChainStage: 'loading',
    rootCauses: [
      '主导手错误：右手（主手）过度用力拉拽，非优势手（左手）未承担主打角色。',
      '双脚站姿不稳，重心未压在右脚前脚掌。',
      '引拍过高且紧贴身体，挥拍没有充分向前伸展。'
    ],
    remedyAction: '【非主导手主控原则】将双反视为“非持拍手的正手击球”（右手持拍者的左手正手）。左手握在拍柄上方承担70%的推击与刷旋力量，右手仅作平衡与导向。',
    proComparison: {
      flawedHabit: '右手紧抓拍柄猛拉，左手毫无感觉，球速慢且回球浅',
      proExecution: '左手强力向前刷出，双臂形成完整的伸展大三角形，随挥落于右肩之后',
      proPlayerExample: '诺瓦克·德约科维奇 (Novak Djokovic) / 郑钦文 (Zheng Qinwen)'
    },
    correctiveDrills: [
      {
        name: '左手单手正手击球强化 Drill',
        intensity: '中等 (30球 x 3组)',
        description: '右手完全松开，单用左手（握在拍柄上方位置）像打正手一样对墙或手抛击球，找回非主导手发力的推击实感。'
      }
    ]
  },
  {
    id: 'srv_waiter_tray',
    stroke: 'serve',
    symptom: '发球“端盘子”推发无力量 (Waiter’s Tray Serve Fault)',
    symptomEn: 'Waiter’s Tray Serve Motion (No Internal Shoulder Rotation)',
    severity: 'common',
    kineticChainStage: 'racket_lag',
    rootCauses: [
      '错误使用东方式正手握拍发球，而非大陆式握拍（Continental Grip）。',
      '引拍向上时拍面朝天（如餐厅服务员托着盘子），丧失了背手搔背（Racket Drop）与前臂内旋（Pronation）的爆发力。',
      '发球完全靠手臂向下推砸，无法产生超过时速100公里的速度。'
    ],
    remedyAction: '【大陆式握拍 + 拍头下坠挠背 + 前臂内旋】切换为菜刀式大陆式握拍。引拍时拍框领先（拍面侧立垂直地面），将拍头掉入背后像挠痒，向上击球瞬间前臂极速内旋翻转。',
    proComparison: {
      flawedHabit: '手心朝上端盘子直推，动作僵硬且容易拉伤肩袖肌群',
      proExecution: '大陆式引拍，拍框切向来球，触球前瞬间内旋爆发出清脆鞭打声',
      proPlayerExample: '皮特·桑普拉斯 (Pete Sampras) / 罗杰·费德勒 (Roger Federer)'
    },
    correctiveDrills: [
      {
        name: '挥掷旧网球与毛巾鞭打 Drill',
        intensity: '高专注度 (20次投掷)',
        description: '不用球拍，用发球动作全力将一颗网球投向对方深区底线，感知肩背如投石机般内旋甩出的肌肉记忆。'
      },
      {
        name: '大陆式握拍拍框击球感知 Drill',
        intensity: '轻度 (20球)',
        description: '故意用拍框边缘向上去切击抛起的球，消除端盘子拍面朝天的心理恶疾。'
      }
    ]
  },
  {
    id: 'vol_big_swing',
    stroke: 'volley',
    symptom: '网前截击大幅度引拍漏球或出界 (Big Backswing at Net)',
    symptomEn: 'Excessive Backswing on Volleys Leading to Framed/Late Hits',
    severity: 'critical',
    kineticChainStage: 'unit_turn',
    rootCauses: [
      '将截击误认为底线抽球，引拍拉到肩膀后方，在极速近距离来球面前无法按时触球。',
      '没有迎前垫步拦截，手腕松懈晃动。'
    ],
    remedyAction: '【眼见拍面 + 短促推截】在引拍时球拍绝对不能超出眼睛余光范围（Keep racquet head in front of your nose）。截击不是挥拍打，而是像用拍面挡住一扇门，向前下方轻切推压。',
    proComparison: {
      flawedHabit: '大引拍拉到脑后，触球点在耳朵后方，球高高弹飞出界',
      proExecution: '拍头竖立在视线前方，身体向前跨出对侧脚迎截，动作短促利落',
      proPlayerExample: '斯特凡·埃德伯格 (Stefan Edberg) / 鲍勃·布莱恩 (Bob Bryan)'
    },
    correctiveDrills: [
      {
        name: '背靠铁丝网截击练习 Drill',
        intensity: '中等 (40球)',
        description: '背部紧贴球场围网站立接截击球，球拍后拉立刻会撞上铁丝网，物理性杜绝大引拍恶习。'
      }
    ]
  }
];

export function getFaultById(id: string): BiomechanicalFault | undefined {
  return BIOMECHANICAL_FAULTS.find(f => f.id === id);
}
